import React, { useRef, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as cafeActions from '../../redux/cafes/actions';
import ENUMS from '../../enums';

const CafeEventFilter = props => {
  let [selectedStatusCheckbox, setSelectedStatusCheckbox] = useState([]);
  let formRefrence = useRef();

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setSelectedStatusCheckbox([]);
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => {
          props.applyFilters(event);
        }}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex col-7 justify-content-end mx-1 py-2 my-2">
            <span className="col-2 text-center d-flex align-items-center">{locales('tables.status')} : </span>
            <div className="col-10 p-0 d-flex justify-content-center align-items-center">
              {ENUMS.EVENT_STATUS.list.map((bankStatus, index) => (
                <div className={`col-3 d-flex p-0`} key={index}>
                  <input
                    type="checkbox"
                    value={bankStatus.value}
                    name={`status`}
                    id={`status-${index}`}
                    className="my-2"
                  />
                  <label className="my-2 mx-1" htmlFor={`status-${index}`}>
                    {bankStatus.title}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-cafeEvent" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

const mapStateToProps = state => {
  return {
    cafeNamesLoading: state.cafesReducer.cafeNamesLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamest: state.cafesReducer.cafeNames,
    cafeNamesFailed: state.cafesReducer.cafeNamesFailed,
    cafeNamesMessage: state.cafesReducer.cafeNamesMessage,
    cafeNamesError: state.cafesReducer.cafeNamesError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CafeEventFilter);
